export const getInventoryTransaction = '/inventory/';
